export const event20=[
   {
  "title": "LET'S TALK PLACEMENTS",
  "date": "18 July 2021",
  "for": "4th year(class of 2017-21)",
  "description": "Placements play a huge role in every student's life. The preparation involved for it can be confusing though. Let's talk Placements session delved deeper into the recruitment pattern, placement pointers and the firsthand experiences of our seniors at NCR & TCS Digital. The panelists shared their interview experiences.",
  "imgPaths": ['placement.jpeg','placement_1.jpeg']
},
  
{
  "title": "ACM CODE HEIST",
  "date": "6 June 2021",
  "for": "2nd year IT students",
  "description": "Team ACM_VNRVJIET thanks all of the entrants for participating in the Codeheist contest conducted on 6th June, 2021 for all information technology second year students",
  "imgPaths": ['acm_code_heist.jpeg']
},
{
  "title": "FUNDAMENTALS OF WEBSITE DESIGN",
  "date": "29 May 2021 - 1 June 2021",
  "for": "All Students",
  "description": "A four-day workshop on Web Designing was conducted by ACM VNRVJIET in collaboration with the department of Information Technology, led by a team of students from 2018-2022 batch in the IT department.",
  "imgPaths": ['fundamentals.jpeg']
},
{
  "title": "ARTIFICIAL INTELLIGENCE AND ITS APPLICATIONS",
  "date": "28 May 2021",
  "for": "IT students",
  "description": "ACM_VNRVJIET organized a webinar on Artificial Intelligence and its Applications, featuring Dr. D. Srinivasa Rao, Associate Professor, IT Dept, VNRJIET.",
  "imgPaths": ['artifical.jpeg']
},
{
  "title": "R-PROGRAMMING WORKSHOP",
  "date": "28 April 2021 - 1 May 2021",
  "for": "IT students",
  "description": "A workshop on R-Programming, focusing on data science tools and visualization, was conducted in collaboration with ACM VNRVJIET for all 1st-year IT Department students.",
  "imgPaths": ['r.jpg','r_1.jpg']
}
,
  {
    "title": "CODE IGNITE",
    "date": "5 April 2021 - 7 April 2021",
    "for": "IT students",
    "description": "A developer survey found that Python is the programming language that most people want to learn. Broadly, most emerging technologies use Python as it has a clean syntax, greatly refines the readability of code, and is suitably versatile. With an exponentially growing community around Data Science, Machine Learning, AI, Web Development, and more, Python is a language that opens programming access to the world. So, ACM VNRVJIET conducted a Python Programming Workshop - CODE IGNITE from 05-04-2021 to 07-04-2021. All participants who met the requirements were issued with an e-certificate upon successful completion.",
    "imgPaths": ['codeignite.jpg']
  },
  {
    "title": "CONQUESTADOR",
    "date": "25 January 2021",
    "for": "1st year students",
    "description": "There is no such things as a self-made man. You will reach your goals only with the help of others'. ACM has always working to develop the master mind's and to introduce how the real world of a Engineer works. On 25th Jan, ACM conducted an Interaction session with the help of alumni, final year students and the founder's of a Start-up. During the session, they shared the up's and down's of their careers and experiences with wonderful words of inspiration and fruitful advices. As most of the first year students were involved in the session they gave a proper guidance towards their goals and clarified their doubts.",
    "imgPaths": ['conquestor.jpg']
  },
  {
    "title": "TECH SYMPOSIUM",
    "date": "12 January 2021",
    "for": "1st year IT students (class of 2020-2024)",
    "description": "ACM VNRVJIET is all set to dive into its first event organized for 2020-2024 batch students on 12 January 2021. Do fill the form where you'll be asked a series of questions to know your area of interest in the field of technology, new terminology that you'd like to know about. In the session, we'll be expanding upon some of the most sought-after subjects, the career oppurtunities that these fields provide and their usefulness in today's world. This is an exclusive event for ACM members.",
    "imgPaths": ['tech_symp.jpeg','tech_symp_1.png']
  },

  ]